// extracted by mini-css-extract-plugin
export default {"blocks":"Blocks_blocks__Up2XT"};